import IConfirmComponent from '@components/FormFlow/Interfaces/FormflowComponents/IConfirmComponent';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import { Input } from 'antd';
import React from 'react';
import styled from 'styled-components';

import ProcessContext from '../ProcessContext';

interface IConfirmTaskComponentStateType {
  inputValueConfirmYes: string;
  inputValueConfirmNo: string;
};

export class ConfirmComponent implements IConfirmComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  yesLabel: string;
  noLabel: string;

  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = ComponentType.CONFIRM;
    this.title = '';
    this.yesLabel = 'SIM';
    this.noLabel = 'NÃO';
    return this;
  }
}

export default class ConfirmComponentProcess extends React.Component<IConfirmComponent, IConfirmTaskComponentStateType> {

  constructor(props: IConfirmComponent) {
    super(props);
    this.state = {
      inputValueConfirmYes: this.props.yesLabel || 'SIM',
      inputValueConfirmNo: this.props.noLabel || 'NÃO',
    };
  }

  handleInputValueConfirmYesChange = async (evt: any) => {
    this.setState({ inputValueConfirmYes: evt.target.value });
  }

  handleInputValueConfirmNoChange = async (evt: any) => {
    this.setState({ inputValueConfirmNo: evt.target.value });
  }

  onSave(updateFormflowWithComponent: (component: any) => void) {
    const newComponent = {
      yesLabel: this.state.inputValueConfirmYes,
      noLabel: this.state.inputValueConfirmNo

    }
    updateFormflowWithComponent(newComponent);
  }


  render() {
    const {

    } = this.state
    return (
      <Wrapper>
        <p className="optional-confirm-condition-text" >{I18n.l("label.labelConfirmComponent")}</p>
        <div className="input-confirm-yes">
          <Input
            defaultValue={this.state.inputValueConfirmYes}
            style={{ textAlign: 'center' }}
            maxLength={30}
            onChange={this.handleInputValueConfirmYesChange}
          />

        </div>
        <div className="input-confirm-no">
          <Input
            defaultValue={this.state.inputValueConfirmNo}
            style={{ textAlign: 'center' }}
            maxLength={30}
            onChange={this.handleInputValueConfirmNoChange}
          />

        </div>
        <ProcessContext.Consumer>
          {({ updateProcessComponent }) => (
            <>
              {this.onSave(updateProcessComponent)}
            </>
          )}
        </ProcessContext.Consumer>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
    width:100%;
    .input-confirm-yes{
        margin-top: 1rem;
    }
    .input-confirm-no{
        margin-top: 1rem;
    }
`;
